import { api } from '../configs/axiosConfigs';

export const getPendingListSortShares = async () => {
  return await api.get('/list-sorts/pending-shares');
};
